import React from 'react'
import { Link } from 'gatsby'

const rightArrowImage = require('../../assets/img/right-arrow.svg')

const PostCard = ({ posts }) => {
  return (
    <div className='container-fluid'>
      {posts
        .filter(post => post.node.frontmatter.templateKey === 'article-page')
        .map(({ node: post }) => (
          <div
            className='post-card'
            style={{ border: '1px solid #eaecee' }}
            key={post.id}
          >
            <div className='container content is-flex'>
              <div className='left'>
                <div className='post-card__title'>
                  <Link className='has-text-primary' to={post.fields.slug}>
                    {post.frontmatter.title}
                  </Link>
                </div>
                <div className='post-card__info'>
                  <small>{post.frontmatter.date} by {post.frontmatter.author}</small>
                </div>
                <div className='post-card__content'>
                  <span>{post.excerpt}</span>
                  <Link to={post.fields.slug}><img className='is-block arrow-right' alt='right-arrow' src={rightArrowImage} /></Link>
                </div>
              </div>
              <div className='right post-card__image'>
                {/* <img src={post.frontmatter.cover} alt={post.frontmatter.title} /> */}
                <div style={{ backgroundImage: `url(${post.frontmatter.cover})` }} />
              </div>

            </div>
          </div>
        ))}
    </div>
  )
}

export default PostCard
